import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-sura-loader',
  templateUrl: './sura-loader.component.html',
  styleUrls: ['./sura-loader.component.css']
})
export class SuraLoaderComponent implements OnInit {

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
  }

  ngOnInit(): void {
  }
}
